import styled from 'styled-components';

import { fontSize, FontSizes, fontWeight, FontWeights } from '@calm-web/design-system';

import { SuccessHeader } from '@/components/b2b/Success/styles';

export const SuccessHead = styled(SuccessHeader)`
	${fontSize(FontSizes.lg)}
	${fontWeight(FontWeights.Medium)}
`;
